module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_02.bdc681df.jpg";